export default __webpack_public_path__ + "static/media/mike_2.abf79568.png";